// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"1d658f38","742":"a21ce661","744":"e9cd2d64","829":"d313a258","965":"b6ae1b74"}[chunkId] + ".chunk.js";
};